import {penceFromPounds} from "../../../../utils/currency";

export type AdvancedRentScriptArgs = {
  annualRate: number;
  annualFlatFee: number;
};

function formatPounds(pennies: number): string {
  return Math.round(pennies / 100).toLocaleString("en-GB");
}

export const initAdvancedRentQuote = (el: Element) => {
  const data = el.getAttribute("data-advanced-rent");
  if (!data) {
    console.error("No data found for advanced rent script", el);
    return;
  }

  const {annualRate, annualFlatFee} = JSON.parse(data) as AdvancedRentScriptArgs;

  const rentInput = document.getElementById("ar-rent-input") as HTMLInputElement | null;
  const dateInput = document.getElementById("ar-date-input") as HTMLInputElement | null;
  const card = document.getElementById("ar-quote-card");
  const headlineEl = document.getElementById("ar-headline");
  const cta = document.getElementById("ar-cta") as HTMLButtonElement | null;

  if (!rentInput) {
    return;
  }

  const calculatePayout = (monthlyRentPennies: number) => {
    const gross = monthlyRentPennies * 12;
    const rateFee = Math.floor(annualRate * gross);
    return Math.max(gross - rateFee - annualFlatFee, 0);
  };

  const render = () => {
    const raw = rentInput.value.replace(/[^0-9]/g, "");
    const parsed = Number.parseInt(raw, 10);
    const hasRent = !Number.isNaN(parsed) && parsed > 0;
    const hasDate = !!dateInput?.value;
    const monthlyRentPennies = hasRent ? penceFromPounds(parsed) : 0;

    if (card) {
      card.dataset["state"] = hasRent ? "filled" : "empty";
    }
    if (cta) {
      cta.disabled = !hasRent || !hasDate;
    }
    if (hasRent && headlineEl) {
      headlineEl.textContent = formatPounds(calculatePayout(monthlyRentPennies));
    }
  };

  render();

  const form = rentInput.closest("form");
  form?.addEventListener(
    "submit",
    () => {
      rentInput.value = rentInput.value.replace(/,/g, "");
    },
    true,
  );

  dateInput?.addEventListener("change", render);
  dateInput?.addEventListener("input", render);

  rentInput.addEventListener("input", function () {
    const raw = this.value.replace(/[^0-9]/g, "");
    const cursorPos = this.selectionStart ?? this.value.length;
    const prevLen = this.value.length;

    if (raw !== "") {
      const formatted = Number.parseInt(raw, 10).toLocaleString("en-GB");
      this.value = formatted;
      const newLen = this.value.length;
      this.setSelectionRange(cursorPos + (newLen - prevLen), cursorPos + (newLen - prevLen));
    } else {
      this.value = "";
    }

    render();
  });
};

const el = document.currentScript;
if (el) {
  initAdvancedRentQuote(el);
}
